export default class MathHelper {
    public static median(numbers: number[]) {
        const medians = numbers.sort((a, b) => a - b);
        const middle = Math.floor(medians.length / 2);
        return medians.length % 2 !== 0 ? medians[middle] : (medians[middle - 1] + medians[middle]) / 2;
    }
}
